function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3558 4.80533C22.9059 0.255227 30.3091 0.255156 34.8592 4.80526C39.4093 9.35536 39.4093 16.7587 34.8592 21.3087C31.7513 24.4188 27.2503 25.417 23.096 24.0702L20.3754 26.7548C20.1766 26.9537 19.9072 27.0656 19.6254 27.0656H17.686V29.0408C17.686 29.3433 17.5565 29.6314 17.3307 29.8334C17.1038 30.0343 16.8023 30.1348 16.5029 30.0944L14.8909 29.9069L14.6806 32.1405C14.6329 32.6482 14.232 33.0491 13.7243 33.0968L11.4907 33.3071L11.6772 34.9191C11.7145 35.2414 11.6026 35.5625 11.3737 35.7915L9.87355 37.2926C9.67467 37.4916 9.40529 37.6035 9.12352 37.6035H3.12202C2.53564 37.6035 2.06116 37.129 2.06116 36.5426V30.5411C2.06116 30.2593 2.17304 29.99 2.37199 29.791L15.5141 16.6489C14.1683 12.4935 15.2479 7.9133 18.3558 4.80533Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.3951 3.14129C26.2067 -1.04714 19.392 -1.04707 15.2036 3.14135C12.3426 6.00228 11.3489 10.2184 12.5877 14.0435L0.490227 26.141C0.307094 26.3241 0.204102 26.572 0.204102 26.8315V32.3559C0.204102 32.8957 0.640874 33.3325 1.18064 33.3325H6.7051C6.96447 33.3325 7.21244 33.2295 7.39551 33.0463L8.7764 31.6645C8.98713 31.4537 9.09012 31.1581 9.05581 30.8615L8.88414 29.3776L10.9402 29.184C11.4075 29.1401 11.7766 28.7711 11.8205 28.3038L12.0141 26.2477L13.4979 26.4203C13.7735 26.4575 14.0511 26.3649 14.2599 26.18C14.4678 25.9941 14.587 25.7289 14.587 25.4505V23.6322H16.3722C16.6316 23.6322 16.8796 23.5292 17.0626 23.3461L19.5669 20.8749C23.391 22.1147 27.5342 21.1958 30.3951 18.3329C34.5836 14.1446 34.5836 7.32972 30.3951 3.14129ZM27.6325 10.0467C26.49 11.1892 24.6323 11.1892 23.4899 10.0467C22.3474 8.90422 22.3474 7.04652 23.4899 5.90404C24.6323 4.76156 26.49 4.76156 27.6325 5.90404C28.775 7.04652 28.7749 8.90422 27.6325 10.0467Z",
  fill: "#055445",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 20.1665,
  y1: 1.39272,
  x2: 10.5103,
  y2: 41.2244,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EF8031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF8031",
  stopOpacity: 0
})));

function SvgKeyVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyVector);
export default __webpack_public_path__ + "static/media/keyVector.ac6f0bf7267155a233f70238671dde90.svg";
export { ForwardRef as ReactComponent };